// extracted by mini-css-extract-plugin
module.exports = {"person":"Person_person__2OwME","person-name":"Person_person-name__boTYg","person-role":"Person_person-role__11dWK","person-image":"Person_person-image__Xmt1X"};